var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qk-iframe"},[_c('iframe',{staticStyle:{"background-color":"transparent","width":"100%","min-height":"100%"},attrs:{"src":_vm.url,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }